module.exports = __webpack_public_path__ + "static/media/builder-landing-help-1.fff61053.svg";